module.exports = __webpack_public_path__ + "img/logo_new.3163e6ac.png";